import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хүсэлтүүд")
const _hoisted_5 = {
  key: 0,
  class: "card shadow"
}
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Хүсэлт")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Хүсэлт үүсгэх ")
const _hoisted_11 = {
  class: "card-body",
  style: {"padding":"20px 0 10px 0"}
}
const _hoisted_12 = { style: {"padding":"0 30px","display":"flex","align-items":"center","justify-content":"space-between","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_13 = { style: {"display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Цэвэрлэх ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Засах")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Устгах")
const _hoisted_19 = { class: "request-header-filter" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Түлхүүр нэр", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "request-header-filter" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Талбар", -1)
const _hoisted_24 = {
  key: 0,
  class: "mail-status-cell"
}
const _hoisted_25 = {
  key: 0,
  class: "text-muted d-block mt-1"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-warning text-danger ms-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Дахин илгээх ")
const _hoisted_28 = { class: "request-pagination-bar" }
const _hoisted_29 = { class: "request-bulk-actions" }
const _hoisted_30 = {
  key: 0,
  class: "request-bulk-action-group"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Зөвшөөрөх ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Цуцлах ")
const _hoisted_33 = {
  key: 1,
  class: "request-bulk-action-group"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Батлах ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Татгалзах ")
const _hoisted_36 = {
  key: 0,
  class: "request-detail"
}
const _hoisted_37 = { class: "request-detail__label" }
const _hoisted_38 = { class: "request-detail__value" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Хаах")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Буцаах / устгах ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Сануулах ")
const _hoisted_42 = { class: "px-2" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Засах (UPDATE)")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Устгах (DELETE)")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Иргэн")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("ААН")
const _hoisted_47 = {
  class: "w-100",
  style: {"display":"flex","gap":"8px"}
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Хайх ")
const _hoisted_49 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "Нэр:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("b", null, "Хэрэглэгчийн дугаар:", -1)
const _hoisted_52 = {
  key: 0,
  class: "mb-2 request-selected-row"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Илгээх ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (
      _ctx.$hasAnyRole(
        'ROLE_REQUEST_REVISE',
        'ROLE_REQUEST_APPROVE',
        'ROLE_REQUEST_CREATE'
      ) && _ctx.$isMbUser
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.$hasAnyRole('ROLE_REQUEST_CREATE') && _ctx.$isMbUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: _ctx.openAddModal
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  icon: "el-icon-close",
                  size: "mini",
                  type: "text",
                  onClick: _ctx.clearFilters
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.pageSize,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                  max: 100,
                  min: 1,
                  size: "mini",
                  onChange: _ctx.handleChange
                }, null, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.filterRequestType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterRequestType) = $event)),
                  clearable: "",
                  placeholder: "Үйлдэл",
                  size: "mini",
                  style: {"width":"120px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "Засах (UPDATE)"
                    }),
                    _createVNode(_component_el_option, {
                      value: 2,
                      label: "Устгах (DELETE)"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.filterStatus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterStatus) = $event)),
                  clearable: "",
                  placeholder: "Төлөв",
                  size: "mini",
                  style: {"width":"140px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Үүсгэсэн",
                      value: "PENDING"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Зөвшөөрсөн",
                      value: "CHECKED"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Баталсан",
                      value: "APPROVED"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Татгалзсан",
                      value: "REJECTED"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.filterCreatedBy,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCreatedBy) = $event)),
                  clearable: "",
                  filterable: "",
                  placeholder: "Үүсгэсэн",
                  size: "mini",
                  style: {"width":"150px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creatorOptions, (creator) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: creator,
                        label: creator,
                        value: creator
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.customerSearch,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerSearch) = $event)),
                placeholder: "Хайх утга аа оруулна уу...",
                "prefix-icon": "el-icon-search",
                size: "mini",
                style: {"width":"35%","min-width":"260px"}
              }, null, 8, ["modelValue"])
            ]),
            true
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  "cell-style": { textAlign: 'center' },
                  data: _ctx.filteredTableData,
                  "header-cell-style": { textAlign: 'center' },
                  "row-class-name": _ctx.requestRowClassName,
                  border: "",
                  "element-loading-text": "Өгөгдөл татаж байна...",
                  "empty-text": "Өгөгдөл байхгүй байна.",
                  size: "mini",
                  style: {"width":"100%","margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "№",
                      prop: "id",
                      width: "60"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          class: "request-table-link",
                          type: "text",
                          onClick: ($event: any) => (_ctx.openRequestDetail(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.id), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Төрөл",
                      width: "80"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.requestType === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: "success"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 1
                              })
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Хүснэгт",
                      prop: "refType",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Хүснэгтийн ID",
                      prop: "refId",
                      sortable: "",
                      width: "150"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Харилцагчийн нэр",
                      prop: "customerName",
                      sortable: "",
                      width: "120"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Регистр / ИБД",
                      prop: "customerId",
                      sortable: "",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "keyName",
                      sortable: "",
                      width: "120"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.filterKeyName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterKeyName) = $event)),
                            clearable: "",
                            filterable: "",
                            placeholder: "Бүгд",
                            size: "mini",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyNameOptions, (keyName) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: keyName,
                                  label: keyName,
                                  value: keyName
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      "class-name": "request-key-value-column",
                      label: "Түлхүүр утга",
                      prop: "keyValue",
                      sortable: "",
                      width: "150"
                    }, {
                      default: _withCtx((scope) => [
                        (_ctx.isNavigableRequest(scope.row))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "request-table-link",
                              type: "text",
                              onClick: ($event: any) => (_ctx.openRequestTarget(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.keyValue), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.keyValue), 1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "fieldName",
                      sortable: "",
                      width: "120"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.filterFieldName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterFieldName) = $event)),
                            clearable: "",
                            filterable: "",
                            placeholder: "Бүгд",
                            size: "mini",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldNameOptions, (fieldName) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: fieldName,
                                  label: fieldName,
                                  value: fieldName
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Анхны утга",
                      prop: "oldValueString",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Шинэ утга",
                      prop: "newValueString",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Тайлбар",
                      prop: "requestReason",
                      width: "200"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Төлөв",
                      prop: "statusText",
                      sortable: "",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Үүсгэсэн",
                      prop: "createdBy",
                      sortable: "",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      formatter: _ctx.$filters.formatDateYMDHMS,
                      label: "Үүсгэсэн огноо",
                      prop: "createdDate",
                      sortable: "",
                      width: "150"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "Хянасан",
                      prop: "checkedBy",
                      sortable: "",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      formatter: _ctx.$filters.formatDateYMDHMS,
                      label: "Хянасан огноо",
                      prop: "checkedDate",
                      sortable: "",
                      width: "150"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "Баталсан",
                      prop: "approvedBy",
                      sortable: "",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, {
                      formatter: _ctx.$filters.formatDateYMDHMS,
                      label: "Баталсан огноо",
                      prop: "approvedDate",
                      sortable: "",
                      width: "150"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      label: "ЗМҮҮЭ мейл",
                      prop: "pcrMailStatusText",
                      sortable: "",
                      width: "190"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.status === 'APPROVED')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createVNode(_component_el_tag, {
                                type: _ctx.pcrMailTagType(scope.row.pcrMailStatus),
                                size: "mini",
                                effect: "plain"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.pcrMailStatusLabel(scope.row)), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]),
                              (scope.row.pcrMailSentDate)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.$filters.formatDateYMDHMS(scope.row, null, scope.row.pcrMailSentDate)), 1))
                                : _createCommentVNode("", true),
                              (scope.row.pcrMailLastError)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 1,
                                    content: scope.row.pcrMailLastError,
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_26
                                    ]),
                                    _: 2
                                  }, 1032, ["content"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.$hasAnyRole('ROLE_REQUEST_REVISE') && _ctx.$isMbUser)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: "Зөвшөөрөх",
                          width: "130px"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.status === 'PENDING')
                              ? (_openBlock(), _createBlock(_component_el_button_group, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      icon: "fas fa-check fs-6 text-light",
                                      round: "",
                                      size: "mini",
                                      type: "success",
                                      onClick: ($event: any) => (_ctx.sendOnce('revise', scope.row.id))
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      icon: "fa fa-times fs-6 text-light",
                                      round: "",
                                      size: "mini",
                                      type: "danger",
                                      onClick: ($event: any) => (_ctx.sendOnce('cancel', scope.row.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.$hasAnyRole('ROLE_REQUEST_APPROVE'))
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          label: "Батлах",
                          width: "170px"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.status === 'CHECKED')
                              ? (_openBlock(), _createBlock(_component_el_button_group, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      icon: "fas fa-check fs-6 text-light",
                                      round: "",
                                      size: "mini",
                                      type: "success",
                                      onClick: ($event: any) => (_ctx.sendOnce('approve', scope.row.id))
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      icon: "fa fa-times fs-6 text-light",
                                      round: "",
                                      size: "mini",
                                      type: "danger",
                                      onClick: ($event: any) => (_ctx.sendOnce('deny', scope.row.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_ctx.canResendPcrMail(scope.row))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    loading: _ctx.resendingPcrMailId === scope.row.id,
                                    icon: "el-icon-message",
                                    round: "",
                                    size: "mini",
                                    type: "warning",
                                    onClick: ($event: any) => (_ctx.resendPcrMail(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_27
                                    ]),
                                    _: 2
                                  }, 1032, ["loading", "onClick"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.$hasAnyRole('ROLE_REQUEST_CREATE') && _ctx.$isMbUser)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          label: "Буцаах",
                          width: "90px"
                        }, {
                          default: _withCtx((scope) => [
                            (_ctx.canWithdrawRequest(scope.row))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  icon: "el-icon-delete",
                                  round: "",
                                  size: "mini",
                                  type: "danger",
                                  onClick: ($event: any) => (_ctx.withdrawRequest(scope.row))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data", "row-class-name"])), [
                  [_directive_loading, this.loadingtable]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (_ctx.canReviseRequests)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_component_el_button, {
                        plain: "",
                        size: "mini",
                        type: "success",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sendAll('reviseAll')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        plain: "",
                        size: "mini",
                        type: "danger",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sendAll('cancelAll')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.canApproveRequests)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_el_button, {
                        plain: "",
                        size: "mini",
                        type: "success",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendAll('approveAll')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        plain: "",
                        size: "mini",
                        type: "danger",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendAll('denyAll')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_pagination, {
                  class: "request-pagination",
                  "current-page": _ctx.page,
                  "page-size": _ctx.pageSize,
                  total: _ctx.filteredRecordCount,
                  layout: "total, prev, pager, next, jumper",
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showRequestDetailModal,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showRequestDetailModal) = $event)),
      title: "Хүсэлтийн мэдээлэл",
      width: "720px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showRequestDetailModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_39
          ]),
          _: 1
        }),
        (_ctx.canWithdrawRequest(_ctx.selectedRequest))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              loading: _ctx.withdrawing,
              type: "danger",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.withdrawRequest(_ctx.selectedRequest)))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.canRemindRequest(_ctx.selectedRequest))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              loading: _ctx.reminding,
              type: "warning",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.remindRequest(_ctx.selectedRequest)))
            }, {
              default: _withCtx(() => [
                _hoisted_41
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.selectedRequest)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestDetailRows, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "request-detail__row"
                }, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(item.label), 1),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(item.value || "-"), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showAddModal,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showAddModal) = $event)),
      "close-on-click-modal": false,
      title: "Хүсэлт үүсгэх",
      width: "1200px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: _ctx.submitting,
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showAddModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          loading: _ctx.submitting,
          type: "primary",
          onClick: _ctx.submitAdd
        }, {
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_el_form, {
            ref: "addFormRef",
            model: _ctx.addForm,
            rules: _ctx.addRules,
            "label-width": "160px",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Үйлдэл",
                prop: "actionType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.addForm.actionType,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addForm.actionType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "UPDATE" }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "DELETE" }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Харилцагчийн төрөл",
                prop: "isCitizen"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.addForm.isCitizen,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addForm.isCitizen) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.addForm.isCitizen === 1 ? 'ИБД / Регистр' : 'Регистр / УБД',
                prop: "customerId"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.addForm.customerId,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addForm.customerId) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: 
                _ctx.addForm.isCitizen === 1
                  ? 'Ж: 12 оронтой civilId эсвэл РД'
                  : 'Ж: 7 оронтой регистр'
              ,
                      clearable: "",
                      onKeyup: _withKeys(_ctx.fetchCustomerMeta, ["enter"])
                    }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
                    _createVNode(_component_el_button, {
                      loading: _ctx.loadingMeta,
                      onClick: _ctx.fetchCustomerMeta
                    }, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  (_ctx.addForm.customerName || _ctx.addForm.refId)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_49, [
                        _hoisted_50,
                        _createTextVNode(" " + _toDisplayString(_ctx.addForm.customerName || "-") + "  |  ", 1),
                        _hoisted_51,
                        _createTextVNode(" " + _toDisplayString(_ctx.addForm.refId || "-"), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: "Талбар",
                prop: "selectedPath"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_cascader, {
                    modelValue: _ctx.addForm.selectedPath,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addForm.selectedPath) = $event)),
                    options: _ctx.cascaderOptions,
                    props: { checkStrictly: false, expandTrigger: 'hover' },
                    class: "w-100",
                    clearable: "",
                    filterable: "",
                    "popper-class": "request-row-cascader",
                    placeholder: "Модуль → Мөр → Талбар сонгоно уу",
                    onChange: _ctx.onCascaderChange
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _: 1
              }),
              (_ctx.selectedFieldMeta)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createVNode(_component_el_tag, {
                      size: "small",
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectedFieldMeta.tableLabel), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tag, {
                      class: "request-selected-row__detail",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectedFieldMeta.keyLabel), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.addForm.actionType === 'UPDATE')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "Анхны утга"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.selectedFieldMeta?.options?.length)
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 0,
                            value: _ctx.resolvedOldValue,
                            class: "w-100",
                            readonly: ""
                          }, null, 8, ["value"]))
                        : (['number', 'decimal'].includes(_ctx.selectedFieldMeta?.type))
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              value: _ctx.formatCurrency(_ctx.addForm.oldValue),
                              class: "w-100 text-right",
                              readonly: "",
                              type: "text"
                            }, null, 8, ["value"]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 2,
                              modelValue: _ctx.addForm.oldValue,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addForm.oldValue) = $event)),
                              class: "w-100",
                              readonly: ""
                            }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.addForm.actionType === 'UPDATE')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    label: "Шинэ утга",
                    prop: "newValue"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.selectedFieldMeta?.options?.length)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            modelValue: _ctx.addForm.newValue,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addForm.newValue) = $event)),
                            class: "w-100",
                            filterable: "",
                            placeholder: "Сонгоно уу"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFieldMeta.options, (opt) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: opt.value,
                                  label: opt.label,
                                  value: opt.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : (['date', 'timestamp'].includes(_ctx.selectedFieldMeta?.type))
                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                              key: 1,
                              modelValue: _ctx.addForm.newValue,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addForm.newValue) = $event)),
                              class: "w-100",
                              type: 
                _ctx.selectedFieldMeta?.type === 'timestamp' ? 'datetime' : 'date'
              ,
                              format: 
                _ctx.selectedFieldMeta?.type === 'timestamp'
                  ? 'YYYY-MM-DD HH:mm:ss'
                  : 'YYYY-MM-DD'
              ,
                              "value-format": 
                _ctx.selectedFieldMeta?.type === 'timestamp'
                  ? 'YYYY-MM-DD HH:mm:ss'
                  : 'YYYY-MM-DD'
              ,
                              placeholder: "Огноо сонгоно уу"
                            }, null, 8, ["modelValue", "type", "format", "value-format"]))
                          : (['number', 'decimal'].includes(_ctx.selectedFieldMeta?.type))
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 2,
                                modelValue: _ctx.addForm.newValue,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addForm.newValue) = $event)),
                                formatter: _ctx.formatCurrency,
                                min: 0,
                                parser: _ctx.parseCurrency,
                                placeholder: "0.00",
                                class: "w-100 text-right",
                                "controls-position": "right"
                              }, null, 8, ["modelValue", "formatter", "parser"]))
                            : (_openBlock(), _createBlock(_component_el_input, {
                                key: 3,
                                modelValue: _ctx.addForm.newValue,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.addForm.newValue) = $event)),
                                class: "w-100",
                                clearable: ""
                              }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "Хүсэлтийн шалтгаан",
                prop: "reason"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.addForm.reason,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.addForm.reason) = $event)),
                    rows: 2,
                    maxlength: "250",
                    "show-word-limit": "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.metaError)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 3,
                    title: _ctx.metaError,
                    class: "mb-2",
                    "show-icon": "",
                    type: "warning"
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}